import moment from 'moment'

import {
  LOADING_ARRAY,
  LIST_EVENTS_REQUEST,
  LIST_EVENTS_RESPONSE,
  LOGOUT_RESPONSE,
} from '../constants'

// timeseriesId -> [events...]
const initialState = {}

export default function update(state = initialState, action) {
  switch (action.type) {
    case LIST_EVENTS_REQUEST:
      return {
        ...state,
        [action.timeseriesId]: state[action.timeseriesId] || LOADING_ARRAY,
      }

    case LIST_EVENTS_RESPONSE: {
      const events = action.events || []
      events.sort((a, b) => moment(a.timestamp) - moment(b.timestamp))

      return {
        ...state,
        [action.timeseriesId]: events,
      }
    }

    case LOGOUT_RESPONSE:
      return initialState
    default:
      return state
  }
}
